import {$qsAll} from '../../../@shared/ts/dom';
import {type InitMessage} from '../../../@type/window-messages';
import {MerchantConfiguration, updateMerchantCurrencyConfig} from '../reducers/merchantConfigurationReducer';
import {store} from '../store';

export function initCurrency(message: InitMessage) {
	initCurrencyEvents();

	store.dispatch(updateMerchantCurrencyConfig({
		name: message.phpData.currency_info?.name ?? 'United States Dollar',
		code: message.phpData.currency_info?.code ?? 'USD',
		symbol: message.phpData?.currency_info?.symbol ?? '$',
		thousands_separator: message.phpData.currency_info?.thousands_separator ?? ',',
		decimal_separator: message.phpData.currency_info?.decimal_separator ?? '.',
		number_of_decimals: message.phpData.currency_info?.number_of_decimals ?? 2,
		position: message.phpData.currency_info?.position ?? 'left',
		rounding: message.phpData.currency_info?.rounding ?? 'disabled',
		hidden: message.phpData.currency_info?.hidden ?? false,
	}));
}

function initCurrencyEvents() {
	// Set currency symbols whenever the modal currency state changes.
	store.subscribe(() => {
		renderCurrencySymbols();
	});
}

/**
 * Renders the text content of all elements with the class
 * ".currency-symbol,.currency-symbol-after" with the
 * current currency values.
 */
function renderCurrencySymbols() {
	const {position, symbol} = MerchantConfiguration.currency.configuration();

	const right = position === 'right' || position === 'right_space';
	for (const $element of $qsAll(`.currency-symbol${right ? '-after' : ''}`)) {
		$element.innerHTML = symbol;
	}
}
